import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import Vue from 'vue';
import axios from 'axios';
import { vxm } from '@/store.vuex';
import { ClientConfigs } from './ClientConfigs';
import { cssTemplate } from './companyThemeCssTemplate';
import { BrandingInfo } from '../branding/branding';
declare var window: any;

@Module({ namespacedPath: 'configs/' })
export class ConfigStore extends VuexModule {
  private clientConfigs: ClientConfigs = new ClientConfigs();
  private globalConfig: any = {};
  private companyPreference: any = {};
  private socialLoginConfigs: any = {};

  public getCompanyCode(): string {
    return this.clientConfigs ? this.clientConfigs.companyCode : '';
  }

  public get ClientConfigs(): ClientConfigs {
    return this.clientConfigs;
  }

  get IsConfigJSONEnabled() {
    return window.WorkLLama.isConfigJSONEnabled === 'true';
  }

  get getCompanyPreference() {
    return (configName, newconfigName) => {
      if (vxm.configs.IsConfigJSONEnabled) {
        return vxm.configs.ClientConfigs.companyPreference[newconfigName];
      }
      return vxm.jobs.BrandingInfo[configName];
    };
  }

  get getGlobalConfigValue() {
    return (configName) => {
      return vxm.configs.IsConfigJSONEnabled
        ? this.globalConfig[configName]
        : vxm.jobs.BrandingInfo[configName];
    };
  }

  get isReferralEnabled(){
    return (configName) => {
      return vxm.configs.IsConfigJSONEnabled
        ? this.globalConfig[configName]
        :  vxm.jobs.BrandingInfo[configName];
    };
  }

  get getGlobalConfigBooelanValue() {
    return (configName) => {
      if (vxm.configs.IsConfigJSONEnabled) {
        return this.globalConfig[configName];
      } else {
        if (typeof vxm.jobs.BrandingInfo[configName] === 'string') {
          return vxm.jobs.BrandingInfo[configName] === 'true';
        } else {
          return vxm.jobs.BrandingInfo[configName];
        }
      }
    };
  }

  get subSectionEnabledInHomePage() {
    return (sectionKey, oldKey) => {
      if (vxm.configs.IsConfigJSONEnabled) {
        const home = this.clientConfigs.slideMenuOptions.find(
          (option) => option.sectionKey === 'HOME',
        );
        if (!home) {
          return false;
        }
        const subSection = home.subSections.find(
          (option) => option.sectionKey === sectionKey,
        );
        if (!subSection) {
          return false;
        }
        return subSection;
      }
      return vxm.jobs.BrandingInfo[oldKey];
    };
  }

  get getHomePageContent() {
    return (newKeyName, oldKeyName) => {
      if (vxm.configs.IsConfigJSONEnabled) {
        return this.globalConfig[newKeyName];
      }
      return (
        vxm.jobs.BrandingInfo.HOME_CONTENT &&
        vxm.jobs.BrandingInfo.HOME_CONTENT[oldKeyName]
      );
    };
  }

  get canEditEmail() {
    if (vxm.configs.IsConfigJSONEnabled) {
      return this.globalConfig['USER_PROFILE_EMAIL_EDITABLE'];
    } else {
      return vxm.jobs.BrandingInfo.miscConfig.isEditEmailEnabled;
    }
  }

  get canShowFieldInWorkExperience() {
    return (fieldName) => {
      if (vxm.configs.IsConfigJSONEnabled) {
        return vxm.configs.visibilityFieldConfigValue('WORK_EXPERIENCE', fieldName)
      }
      return true
      }
  }

  get visibilityFieldConfigValue() {
    return (sectionKey, field) => {
      let fieldConfigValue: any;
      const section = this.clientConfigs.userProfileSections.find(
        (section) => section.sectionKey === sectionKey,
      );
      if (section && section.fieldConfig) {
        fieldConfigValue = section.fieldConfig.find(
          (fields) => fields.field === field,
        );
        if (fieldConfigValue) {
          return fieldConfigValue.visibility;
        }
      }
      return false;
    };
  }

  get requiredFieldConfigValue() {
    return (sectionKey, field) => {
      let fieldConfigValue: any;
      const section = this.clientConfigs.userProfileSections.find(
        (section) => section.sectionKey === sectionKey,
      );
      if (section && section.fieldConfig) {
        fieldConfigValue = section.fieldConfig.find(
          (fields) => fields.field === field,
        );
        if (fieldConfigValue) {
          return fieldConfigValue.required;
        }
      }
      return false;
    };
  }

  get minimumEntriesFieldConfigValue() {
    return (sectionKey, field) => {
      console.log("section field ", sectionKey," ", field);
      let fieldConfigValue: any;
      const section = this.clientConfigs.userProfileSections.find(
        (section) => section.sectionKey === sectionKey,
      );
      if (section && section.fieldConfig) {
        fieldConfigValue = section.fieldConfig.find(
          (fields) => fields.field === field,
        );
        if (fieldConfigValue) {
          return fieldConfigValue.minimumEntries;
        }
      }
      return 0;
    };
  }


  get slideMenuSubSections() {
    return (sectionKey, subSectionkey) => {
      const section = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (option) => option.sectionKey === sectionKey,
      );
      if (section && section.subSections) {
        const subSections = section.subSections.find(
          (option) => option.sectionKey === subSectionkey,
        );
        return subSections ? subSections : '';
      }
      return '';
    };
  }

  get whatsappNotificationEnabled() {
    if (vxm.configs.IsConfigJSONEnabled) {
      // return vxm.configs.visibilityFieldConfigValue(
      //   'NOTIFICATION_PREFERENCE',
      //   'NOTIFICATION_PREFERENCE_WHATSAPP',
      // );
      const config = this.globalConfig['WHATSAPP_NOTIFICATION_PREFERENCE_ENABLED'];
        return config ? config : true;
    } else {
      let notificationPreference = vxm.jobs.BrandingInfo.WL_NOTIFICATION_PREFERENCES.split(
        ',',
      );
      return notificationPreference.includes('WHATSAPP');
    }
  }

  get canHideThisFieldFromFieldConfig() {
    return (configName, sectionKey, field) => {
      if (vxm.configs.IsConfigJSONEnabled) {
        return !vxm.configs.visibilityFieldConfigValue(sectionKey, field);
      }
      return vxm.jobs.BrandingInfo[configName];
    };
  }

  public get SkillSectionTitle() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const section = this.clientConfigs.userProfileConfig.profileSections.find(
        (section) => section.sectionKey === 'SKILLS',
      );
      if (section) {
        return section.displayName;
      }
      return '';
    }
    return vxm.jobs.BrandingInfo.SKILLS_SECTION_TITLE;
  }
  public get CompanyPreference(): any {
    return this.companyPreference;
  }

  public get GlobalConfig(): any {
    return this.globalConfig;
  }

  public get SocialLoginConfig(): any {
    return this.socialLoginConfigs;
  }

  public get getWorkExperiencePermissionConfig() {
    return (permission) => {
      if (  window.WorkLLama.isConfigJSONEnabled === 'true'){

        const workExperienceSection = this.clientConfigs.userProfileSections.find(
          (section) => section.sectionKey === 'WORK_EXPERIENCE',
        );
        if (
          workExperienceSection &&
          workExperienceSection.extraConfig &&
          workExperienceSection.extraConfig.permissionConfig &&
          workExperienceSection.extraConfig.permissionConfig.user
        ) {
          return  workExperienceSection.editable && workExperienceSection.extraConfig.permissionConfig.user[permission];
        }
        else {
          return true
        }
      }
      const step = vxm.users.ProfileWizardSteps.find((step) => {
        return step.stepName === 'WORK_EXPERIENCE';
      });
      if (step && step.meta) {
        const stepMeta = JSON.parse(step.meta);
        let workHistoryConfig = stepMeta.UserWorkHistoryManagemntConfig;
        if (workHistoryConfig) {
          return workHistoryConfig.system[permission];
        }
      }
      return true;
    }

  }

  public get getUserPermissionConfig() {
    return (permission, sectionKey) => {
      if (window.WorkLLama.isConfigJSONEnabled === 'true') {
        const section = this.clientConfigs.userProfileSections.find(
          (section) => section.sectionKey === sectionKey,
        );
        if(section && section.editable){
            if (
              section &&
              section.extraConfig &&
              section.extraConfig.permissionConfig &&
              section.extraConfig.permissionConfig.user
            ) {
              console.log("permission",permission,"value",section.extraConfig.permissionConfig.user['edit'])
              return section.extraConfig.permissionConfig.user[permission];
            }
            else {
              return true
            }
        }
        else{
          return false;
        }
      }
      const step = vxm.users.ProfileWizardSteps.find((step) => {
        return step.stepName === sectionKey;
      });
      if (step && step.meta) {
        const stepMeta = JSON.parse(step.meta);
        let userConfig = stepMeta.UserWorkHistoryManagemntConfig;
        if (userConfig) {
          return userConfig.system[permission];
        }
      }
      return true;
    }
  }

  public get getMinimumEntriesConfig() {
    return (sectionKey) => {
      let minimumEntries = 0;
      if (vxm.configs.IsConfigJSONEnabled) {
        const selectedSection = this.clientConfigs.userProfileSections.find(
          (section) => section.sectionKey === sectionKey,
        );
        if (
          selectedSection &&
          selectedSection.extraConfig &&
          selectedSection.extraConfig.minimumEntries
        ) {
          minimumEntries = selectedSection.extraConfig.minimumEntries;
        }
        return minimumEntries;
      }
      const step = vxm.users.ProfileWizardSteps.find((step) => {
        return step.stepName === sectionKey;
      });
      if (step && step.meta) {
        const stepMeta = JSON.parse(step.meta);
        minimumEntries = stepMeta.minimumEntries || minimumEntries;
      }
      return minimumEntries;
    }
  }

  public get CanAddNewWorkExperience(): boolean {
    if (vxm.configs.IsConfigJSONEnabled) {
      const workExperienceSection = this.clientConfigs.userProfileSections.find(
        (section) => section.sectionKey === 'WORK_EXPERIENCE',
      );
      if (
        workExperienceSection &&
        workExperienceSection.extraConfig &&
        workExperienceSection.extraConfig.permissionConfig &&
        workExperienceSection.extraConfig.permissionConfig.user
      ) {
        return workExperienceSection.extraConfig.permissionConfig.user.add;
      }
      return true;
    }
    return vxm.jobs.BrandingInfo.adduserjobhistory;
  }

  public get GuidedSignupEnabled(): boolean {
    return vxm.configs.IsConfigJSONEnabled
      // ? this.clientConfigs.profileWizardConfig.enabled
      ? this.globalConfig['GSU_ENABLED']
      : vxm.jobs.BrandingInfo.SHOW_GUIDED_SIGNUP;
  }

  @mutation
  public setClientConfigs(bi: ClientConfigs) {
    this.clientConfigs = bi;

    // // Map companyPreference to dictionary
    // const companyPreference = this.clientConfigs.companyPreference || {};
    // const configArray = companyPreference.config || [];
    // this.globalConfig = configArray.reduce((acc, item) => {
    //   acc[item.key] = item.value;
    //   return acc;
    // }, {});

    // Map global config to dictionary
    const globalConfig = this.clientConfigs.globalConfig || {};
    const configArray = globalConfig.config || [];
    this.globalConfig = configArray.reduce((acc, item) => {
      acc[item.key] = item.value;
      return acc;
    }, {});

    // Map socialLoginConfig config to dictionary
    const socialCfgArray = globalConfig.socialLoginConfig || [];
    this.socialLoginConfigs = socialCfgArray.reduce((acc, item) => {
      acc[item.key] = item.value;
      return acc;
    }, {});
    vxm.jobs.setCompanyCode(this.clientConfigs.companyCode);
    let bInfo = new BrandingInfo();
    bInfo.companycode = this.clientConfigs.companyCode;
    vxm.jobs.setBrandingInfo(bInfo);
    window.document.title = this.globalConfig['WL_CANDIDATE_PORTAL_TITLE'];
    vxm.utility.setCandidatePortalTitle(
      this.globalConfig['WL_CANDIDATE_PORTAL_TITLE'],
    );
    vxm.utility.setCandidatePortalApplicationName(
      this.globalConfig['WL_CANDIDATE_PORTAL_APPLICATION_NAME'],
    );
    vxm.jobs.setBrandingLogo(this.globalConfig['CANDIDATE_PORTAL_LOGO_URL']);
    vxm.jobs.setDropboxAppKey(this.globalConfig['DROPBOX_APP_KEY']);

    const audioEyeSiteHash = this.globalConfig['AUDIO_EYE_SITE_HASH'];
    if (audioEyeSiteHash) {
      function a() {
        var b = () => {
          window.__AudioEyeSiteHash = audioEyeSiteHash;
          var a = document.createElement('script');
          a.src = 'https://wsmcdn.audioeye.com/aem.js';
          a.type = 'text/javascript';
          a.setAttribute('async', '');
          document.getElementsByTagName('body')[0].appendChild(a);
        };
        'complete' !== document.readyState
          ? window.addEventListener
            ? window.addEventListener('load', b)
            : window.attachEvent && window.attachEvent('onload', b)
          : b();
      }
      a();
    }

    var style = cssTemplate
      .replace(
        /\$primary-light/g,
        bi.themeConfigResponse.colorPalette.primaryColorLight.rgbValue +
          ' !important',
      )
      .replace(
        /\$secondary-light/g,
        bi.themeConfigResponse.colorPalette.secondaryColorLight.rgbValue +
          ' !important',
      )
      .replace(
        /\$primary/g,
        bi.themeConfigResponse.colorPalette.primaryColor.rgbValue +
          ' !important',
      )
      .replace(
        /\$secondary/g,
        bi.themeConfigResponse.colorPalette.secondaryColor.rgbValue +
          ' !important',
      );

    window.$('html > head').append(window.$(style));
  }

  @action({ mode: 'mutate' })
  public async getClientConfigs({ companyCode }) {
    axios
      //.get(`/configservice/configs/${companyCode}`, {
      .get(`/configservice/configs/TCDEV`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        console.log(response.data);
        let bInfo = new ClientConfigs();
        bInfo = response.data;
        this.setClientConfigs(bInfo);
      })
      .catch((error) => {
        console.log('catch:', error);
      })
      .finally(() => {
        console.log('finally');
      });
  }
}
